import React from "react";
const IconTwitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8C0 5.19974 0 3.79961 0.544967 2.73005C1.02433 1.78924 1.78924 1.02433 2.73005 0.544967C3.79961 0 5.19974 0 8 0H12C14.8003 0 16.2004 0 17.27 0.544967C18.2108 1.02433 18.9757 1.78924 19.455 2.73005C20 3.79961 20 5.19974 20 8V12C20 14.8003 20 16.2004 19.455 17.27C18.9757 18.2108 18.2108 18.9757 17.27 19.455C16.2004 20 14.8003 20 12 20H8C5.19974 20 3.79961 20 2.73005 19.455C1.78924 18.9757 1.02433 18.2108 0.544967 17.27C0 16.2004 0 14.8003 0 12V8ZM16.1726 4H14.0258L10.4883 7.83446L7.4298 4H3L8.29291 10.5631L3.27646 16H5.42451L9.2962 11.8049L12.6799 16H17L11.4825 9.08308L16.1726 4ZM14.4619 14.7815H13.2724L5.50693 5.15446H6.78343L14.4619 14.7815Z"
      fill="currentColor"
    />
  </svg>
);
export default IconTwitter;
